import * as React from "react";
import { cn } from "@/lib/utils";

export type TextareaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement>;

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, ...props }, ref) => {
    return (
      <textarea
        className={cn(
          "flex min-h-[80px] w-full rounded-md border border-input bg-background px-3 py-2 text-sm placeholder:text-muted-foreground",
          "focus:outline-2 focus:outline-offset-[-1px] focus:[outline-color:hsl(var(--primary)/0.45)] focus:ring-0 focus:ring-offset-0",
          "focus-visible:outline-2 focus-visible:outline-offset-[-1px] focus-visible:[outline-color:hsl(var(--primary)/0.45)] focus-visible:ring-0 focus-visible:ring-offset-0",
          // Invalid (error state) – Input ile aynı davranış
          "aria-[invalid=true]:border-destructive aria-[invalid=true]:focus-visible:ring-0 aria-[invalid=true]:focus-visible:ring-offset-0",
          "disabled:cursor-not-allowed disabled:opacity-50",
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);
Textarea.displayName = "Textarea";

export { Textarea };
